import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RecaptchaProvider } from "@/lib/myapp/recaptcha";

export const Route = createFileRoute("/forms/$slug/respond")({
  component: RespondLayout,
});

/**
 * Layout route for the public respond flow.
 * - /respond       -> respond.index.tsx  (the form)
 * - /respond/success -> respond.success.tsx (success confirmation)
 *
 * Wraps with RecaptchaProvider so the form page can conditionally
 * request a captcha token when the API indicates require_captcha=true.
 */
function RespondLayout() {
  return (
    <RecaptchaProvider>
      <Outlet />
    </RecaptchaProvider>
  );
}
